// const apiService = require('../api/apiService.js')
import { getFeedbackItem, createFeedback } from "@/services/feedback"
const feedbackItem = ( self ) => {
    getFeedbackItem( {} ).then( res => {
        let co = res.data
        self.infoList = Object.keys(co).map(res => {return {label: co[res], value: res, checked: false }})
    })
}
const createFeedbackItem = ( self ) => {
    let param = self.feedbackInfo
    createFeedback( param ).then( res => {
        if( res.code == 200 ) {
            self.$showToast({
                type: 'icon',
                toastSuccess: true,
                toastMessage: '信息反馈成功!',
                duration: 2000 
            })
        } else {
            self.$showToast({
                type: 'text',
                toastMessage: '请选择相应的反馈信息!',
                duration: 2000 
            })
        }
    }).catch( () => {
        self.$showToast({
            type: 'icon',
            toastSuccess: false,
            toastMessage: '信息反馈失败!',
            duration: 2000 
        })
    })
}
export default {
  feedbackItem,
  createFeedbackItem
}